export default __webpack_public_path__ + "static/media/necromancerbg.4fa71d98.jpg";